import { render, staticRenderFns } from "./officeSuppliesCollectionTask.vue?vue&type=template&id=44f6e444&scoped=true"
import script from "./officeSuppliesCollectionTask.vue?vue&type=script&lang=js"
export * from "./officeSuppliesCollectionTask.vue?vue&type=script&lang=js"
import style0 from "./officeSuppliesCollectionTask.vue?vue&type=style&index=0&id=44f6e444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f6e444",
  null
  
)

export default component.exports